import React from 'react';
import ListItem from '../ListItem';
import translate from '../../locales';

const __t = translate;


const RateMappingPreview = ({ fromDate, toDate, rates }) => {
    return (
        <div>
            <div style={{ fontSize: '1.1em', overflowX: 'hidden' }}><strong>[{fromDate} - {toDate}]</strong></div>
            <div style={{ marginTop: '5px' }}></div>
            <ListItem.ScrollableXList
                label={`${__t('rates')}:`}
                text={rates}
            />
        </div>
    )
}

export default RateMappingPreview;